import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class TenantHeaderQueryCriteriaClass extends BaseCriteriaModel {
  // hdr table
  code?: Optional<string> = Optional.empty();
  parent_guid?: Optional<string> = Optional.empty();
  subscription_guid?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();

  // app_mst_link_login_subject_to_tenant
  login_subject_guid?: Optional<string> = Optional.empty();

}

export class TenantHeaderCriteriaModelQuery {
  query = '';

  constructor(tenantHeaderCriteriaModel: TenantHeaderQueryCriteriaClass) {

    if (!tenantHeaderCriteriaModel) {
      return;
    }

    this.query += tenantHeaderCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += tenantHeaderCriteriaModel.parent_guid.filter(x => x !== '').map(x => '&parent_guid=' + x).orElse('');
    this.query += tenantHeaderCriteriaModel.subscription_guid.filter(x => x !== '').map(x => '&subscription_guid=' + x).orElse('');
    this.query += tenantHeaderCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');

    this.query += tenantHeaderCriteriaModel.login_subject_guid.filter(x => x !== '').map(x => '&login_subject_guid=' + x).orElse('');

    this.query += '&status=' + tenantHeaderCriteriaModel.status;
    this.query += '&orderBy=' + tenantHeaderCriteriaModel.orderBy;
    this.query += '&order=' + tenantHeaderCriteriaModel.order;
    this.query += '&offset=' + tenantHeaderCriteriaModel.offset + '&limit=' + tenantHeaderCriteriaModel.limit;
  }
}
